(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
if (!customElements.get('ra-announcement-carousel')) {
  customElements.define('ra-announcement-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-track]');
      this.viewport = this.querySelector('[data-viewport]');
      if (!this.track || !this.viewport) return;
      this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.editorPaused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.counter = this.querySelector('[data-counter-display]');
      this.status = this.querySelector('[data-status]');
      this.multiple = this.slides.length > 1;
      this.previous.hidden = this.next.hidden = !this.multiple;
      this.counter.hidden = !this.multiple || this.dataset.counter !== 'true';
      this.hidden = this.slides.length === 0;
      this.slides.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', this.dataset.slideLabel);
        slide.setAttribute('aria-label', `${index + 1} ${this.dataset.slideOf} ${this.slides.length}`);
      });
      this.previous.addEventListener('click', () => this.show(this.index - 1, true), options);
      this.next.addEventListener('click', () => this.show(this.index + 1, true), options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.addEventListener('keydown', event => {
        if (!this.multiple || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let destination = event.key === 'ArrowLeft' ? this.index - 1 : this.index + 1;
        if (event.key === 'Home') destination = 0;
        if (event.key === 'End') destination = this.slides.length - 1;
        this.show(destination, true);
      }, options);
      this.addEventListener('touchstart', event => {
        this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const x = event.changedTouches[0].clientX - this.touch.x;
        const y = event.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y)) {
          this.suppressClickUntil = Date.now() + 500;
          this.show(this.index + (x < 0 ? 1 : -1), true);
        }
        this.touch = null;
      }, { ...options, passive: true });
      this.addEventListener('click', event => {
        if (Date.now() < (this.suppressClickUntil || 0) && event.target.closest('a')) event.preventDefault();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        this.schedule();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index < 0) return;
        this.editorPaused = true;
        this.show(index);
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;
        this.editorPaused = false;
        this.schedule();
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.viewport);
      this.slides.forEach(slide => this.resizeObserver.observe(slide));
      this.setAttribute('data-ready', '');
      this.show(0);
    }
    show(index, announce = false) {
      if (!this.slides.length) return;
      const focusedSlide = this.slides[this.index]?.contains(document.activeElement);
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const inactive = index !== this.index;
        slide.inert = inactive;
        slide.setAttribute('aria-hidden', String(inactive));
      });
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (announce) {
        this.status.textContent = `${this.index + 1} ${this.dataset.slideOf} ${this.slides.length}: ${this.slides[this.index].textContent.trim()}`;
        if (focusedSlide) (this.slides[this.index].querySelector('a') || this.next).focus();
      }
      this.measure();
      this.schedule();
    }
    measure() {
      if (this.slides?.length) this.viewport.style.height = `${this.slides[this.index].getBoundingClientRect().height}px`;
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = null;
      if (!this.multiple || this.dataset.autoplay !== 'true' || this.hovered || this.focused || this.editorPaused || this.motion.matches || document.hidden) return;
      const delay = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.timer = setTimeout(() => this.show(this.index + 1), delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.resizeObserver?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
